import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LayoutDashboard, Building2, PoundSterling, Settings, LogOut, ArrowLeft, ShieldAlert, Mail } from "lucide-react";

const NAV = [
  { to: "/super-admin", label: "Overview", icon: LayoutDashboard, end: true, testid: "super-nav-overview" },
  { to: "/super-admin/attractions", label: "Attractions", icon: Building2, testid: "super-nav-attractions" },
  { to: "/super-admin/revenue", label: "Revenue", icon: PoundSterling, testid: "super-nav-revenue" },
  { to: "/super-admin/interest", label: "Interest", icon: Mail, testid: "super-nav-interest" },
  { to: "/super-admin/settings", label: "Settings", icon: Settings, testid: "super-nav-settings" },
];

export default function SuperAdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#080808] text-[#fafafa]">
      <header className="sticky top-0 z-40 bg-[#100808] border-b border-[#3a1414]">
        <div className="max-w-7xl mx-auto px-6 flex items-center gap-6 h-16">
          <div className="flex items-center gap-2.5">
            <ShieldAlert size={22} className="text-[#dc2626]" />
            <div className="leading-tight">
              <div className="font-bold tracking-tight">ScareTickets</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#dc2626]">Platform Admin</div>
            </div>
          </div>
          <nav className="flex items-center gap-1 ml-4" data-testid="super-nav">
            {NAV.map((n) => {
              const Icon = n.icon;
              return (
                <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
                  className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? "bg-[#2a1212] text-white" : "text-[#9a9a9a] hover:text-white"}`}>
                  <Icon size={16} /> {n.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="ml-auto flex items-center gap-4">
            <button onClick={() => nav("/dashboard/overview")} className="text-sm text-[#9a9a9a] hover:text-white flex items-center gap-1.5" data-testid="super-back-dashboard">
              <ArrowLeft size={14} /> My attraction
            </button>
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium leading-tight">{user?.name}</div>
              <div className="text-[11px] text-[#7a7a7a]">{user?.email}</div>
            </div>
            <button onClick={async () => { await logout(); nav("/login"); }} className="text-[#dc2626] hover:text-[#ef4444]" data-testid="super-logout" title="Sign out"><LogOut size={18} /></button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}

export function SuperCard({ children, className = "" }) {
  return <div className={`bg-[#0e0e0e] border border-[#1c1c1c] rounded-xl ${className}`}>{children}</div>;
}
